import React from "react";
import CustomAccordion from "shared/Accordion/Accordion";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";

const TermsAndConditions = () => {
  return (
    <div data-testid="terms-and-condition-wrapper" className="wrapper">
      <Paper elevation={3} style={{ margin: "0px auto", maxWidth: "85%" }}>
        <Container style={{ padding: "5px 5px" }}>
          <div className="WordSection1">
            <h1>
              <p className="MsoTitle" style={{ marginTop: "12.0pt" }}>
                <span lang="EN-US" style={{ msoNoProof: "yes" }}>
                  Global Challenge for Safe and Secure LLMs – Track 1
                </span>
              </p>
            </h1>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "18.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                TERMS AND CONDITIONS
              </span>
              <span
                style={{
                  fontSize: "18.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                To enter the Challenge, please register via the{" "}
              </span>
              <span style={{ color: "black", msoColorAlt: "windowtext" }}>
                <a
                  href="https://gcss.aisingapore.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "blue", textDecoration: "underline" }}
                >
                  Challenge Website
                </a>
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                .{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Your submissions to the Challenge (“Entry” or “Entries”) must
                conform to the requirements set forth on the Challenge Website.
                Your Entries will be scored by the Challenge Sponsor based on
                the evaluation criteria described on the Challenge Website.
                Prizes will be awarded to the top three teams in the Private
                Leaderboard for Track 1B. Each winning team must submit all
                datasets, code bases, and a 4-page technical report, which will
                be verified by a panel of judges (Technical Review Committee)
                consisting of domain experts.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                  color: "black",
                  msoThemecolor: "text1",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "24.0pt",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 2,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "15.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                CHALLENGE RULES
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                BINDING AGREEMENT
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Please read these Challenge Rules carefully prior to entry, to
                ensure that you understand and agree with the Challenge Rules.
                You agree that submission of an Entry to the Challenge
                constitutes your acceptance of these Challenge Rules and that
                there is a binding legal agreement between You and the Challenge
                Sponsor on the terms set out herein with respect to the
                Challenge (“Agreement”).
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                1. DEFINITIONS
              </span>
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "2.0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-2.0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Challenge”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                refers to the AI Singapore’s Global Challenge for Safe and
                Secure LLMs 2024 Track 1
              </span>
              <span
                lang="EN-US"
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                  msoAnsiLanguage: "EN-US",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "2.0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-2.0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Challenge Partner”
                <a name="_Hlk157502785">
                  <span style={{ msoTabCount: 1 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  </span>
                  refers to{" "}
                </a>
                <span style={{ msoBookmark: "_Hlk157502785" }}>CyberSG</span>
                <span style={{ msoBookmark: "_Hlk157502785" }}>
                  {" "}
                  R&amp;D Programme Office{" "}
                </span>
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "2.0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-2.0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Challenge Period”{" "}
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                refers to the duration of the Challenge as specified on the
                Challenge Website{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "141.75pt",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-141.75pt",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Challenge Sponsor”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                refers to AI Singapore
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "141.75pt",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-141.75pt",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Challenge Task”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                <span style={{ msoTabCount: 1 }}> </span>refers to the Challenge
                task as specified on the Challenge Website
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "141.75pt",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-141.75pt",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Challenge Website”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                <span style={{ msoTabCount: 1 }}> </span>refers to{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                  color: "black",
                  msoColorAlt: "windowtext",
                }}
              >
                https://
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  color: "black",
                  msoColorAlt: "windowtext",
                }}
              >
                gcss.aisingapore.org
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "2.0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-2.0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Entry Deadline(s)”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                refers to the last day for submission of Entries as specified on
                the Challenge Website
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "2.0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-2.0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Public Leaderboard”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                refers to the ranking leaderboard visible to all participants
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "2.0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-2.0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Private Leaderboard”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                refers to the ranking leaderboard that will only be visible to
                the Challenge Sponsor and Challenge Partner
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "2.0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-2.0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Participant” or “You”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                refers to each individual who submits an Entry to the Challenge,
                either individually or as part of a team
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "2.0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-2.0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Participant Datasets”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                refers to all datasets curated by the Participant for the
                purpose of the Challenge and model training activities that is
                sourced by Participant from existing datasets, communities, and
                websites, or synthetically generated through data augmentation
                or generation
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "2.0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-2.0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                lang="EN-GB"
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoAnsiLanguage: "EN-GB",
                }}
              >
                “Prize Ceremony”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                refers to the Challenge Prize Ceremony to be held during the
                Singapore International Cyber Week (SICW) 2024 in October 2024
              </span>
              <span
                style={{ fontSize: "10.5pt", fontFamily: '"Arial",sans-serif' }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "2.0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-2.0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                “Requirements”
                <span style={{ msoTabCount: 1 }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </span>
                refers to the submission requirements as specified on the
                Challenge Website
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                2. ELIGIBILITY CRITERIA
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                A. To be eligible to enter the Challenge, You must:
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoListParagraphCxSpFirst"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "0in",
                marginLeft: "37.5pt",
                msoAddSpace: "auto",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-19.5pt",
                lineHeight: "normal",
                msoList: "l1 level1 lfo7",
              }}
            >
              {/*[if !supportLists]*/}
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: "Symbol",
                  msoFareastFontFamily: "Symbol",
                  msoBidiFontFamily: "Symbol",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                <span style={{ msoList: "Ignore" }}>
                  ·
                  <span style={{ font: '7.0pt "Times New Roman"' }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
              </span>
              {/*[endif]*/}
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                be a registered account holder on the Challenge Website;
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpMiddle"
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "0in",
                marginLeft: "37.5pt",
                msoAddSpace: "auto",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                textIndent: "-19.5pt",
                lineHeight: "normal",
                msoList: "l1 level1 lfo7",
              }}
            >
              {/*[if !supportLists]*/}
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: "Symbol",
                  msoFareastFontFamily: "Symbol",
                  msoBidiFontFamily: "Symbol",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                <span style={{ msoList: "Ignore" }}>
                  ·
                  <span style={{ font: '7.0pt "Times New Roman"' }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
              </span>
              {/*[endif]*/}
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                be at least the older of: (a) 18 years old or (b) the age of
                majority in your country of residence and have the legal right
                and ability to enter and participate in this Challenge, provided
                You are not from countries that are identified as high-risk or
                other monitored jurisdictions by the Financial Action Task Force
                and not part of any list of embargoed countries;
              </span>
            </p>
            <p
              className="MsoListParagraphCxSpLast"
              style={{ textAlign: "justify", textJustify: "inter-ideograph" }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  lineHeight: "107%",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                &nbsp;
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                B. Only individuals are permitted as Participants. For avoidance
                of doubt, individuals registering for this Challenge will be
                doing so in their personal capacity and not representing their
                organizations or institutions, even{" "}
              </span>
              <span
                lang="EN-US"
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoAnsiLanguage: "EN-US",
                  msoFareastLanguage: "ZH-CN",
                }}
              >
                if they{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                have provided their organizational / institutional emails for
                the purpose of registration.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                C. The Challenge Sponsor reserves the right to verify
                eligibility and to adjudicate on any dispute at any time. If the
                Challenge Sponsor shall determine, in its absolute discretion
                and opinion, that You have provided any false or incorrect
                information to the Challenge Sponsor, You may be immediately
                disqualified from the Challenge.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                D. Unless otherwise set forth in the Challenge Rules, employees,
                interns, apprentices, contractors, officers and directors of the
                Challenge Sponsor and Challenge Partner (“Challenge Entities”)
                are not allowed to enter and participate in the Challenge.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                3. INDIVIDUALS AND TEAMS
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                A. Individual Account. In order to participate in the Challenge,{" "}
                You must first register for an account on the Challenge Website.
                You may only submit Entry(ies) once your individual account is
                linked to a team.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                B. Multiple Accounts. You must register for no more than one
                account. You will be disqualified if you submit Entry( ies)
                through more than one account, or attempt to falsify an account
                to act as your proxy
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                  color: "black",
                  msoColorAlt: "windowtext",
                }}
              >
                .
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                C. Teams. You may participate as an individual or form a team
                with other Participants (“Team”), provided that the team does
                not exceed the maximum team size set forth on the Challenge
                Website. You can join or form only one Team; Each Team member
                must have a registered unique account, before joining the
                Challenge as a Team. You must submit your Entry(ies) as a Team.
                The individual information of each Team member will need to be
                furnished during the submission process and each Team must
                designate a Team Captain. Participants intending to join the
                Challenge as individuals will be allowed to create single-member
                teams for the purposes of submissions.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                D. A Team is not allowed to split, disband or remove members
                after registration of the Team through the Challenge Website.
                Please think carefully before building your team.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                4. CHALLENGE PERIOD
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                The Challenge Period and Entry Deadlines are subject to change,
                and Challenge Sponsor may require each Team to make various
                submissions during the Challenge Period, as part of the
                Challenge. Entry deadlines for each submission will be set out
                and/or updated on the Challenge Website. It is each Team’s
                responsibility to check the Challenge Website regularly to stay
                informed of any deadline changes. You are responsible for
                determining the corresponding time zone in your location. The
                Challenge Sponsor reserves the right to cancel or suspend the
                Challenge at any time and to change the form and substance,
                dates for deadlines, and events and/or Requirements of the
                Challenge at its discretion.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                5. CHALLENGE ENTRIES
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                To enter the Challenge, You must register on the Challenge
                Website before the Entry Deadline and follow the instructions
                for developing and submitting your Entry through the Challenge
                Website. Your Entry(ies) must be made in the manner and format
                set forth on the Challenge Website. Entries must be received
                prior to the Entry deadlines set forth on the Challenge Website.
                Entries must be submitted in English.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                  color: "black",
                  msoColorAlt: "windowtext",
                }}
              >
                Entries shall not use or incorporate information from human
                observation/prediction and/or hand labelling of the validation
                dataset or test data records.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Entries are void if any part thereof is illegible, incomplete,
                damaged, altered, counterfeit, obtained through fraud, or late.
                The Challenge Sponsor reserves the right, at its sole
                discretion, to disqualify any Participant who makes an Entry
                that does not meet the Requirements as specified on the
                Challenge Website.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                6. CHALLENGE DATA
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                A. No training data will be released by the Challenge Sponsor
                for this Challenge. The Challenge Sponsor will supply
                Participants with specific data related to the Challenge
                scenarios. This data is to be used solely for the purpose of
                participating in the Challenge and enhancing the submissions.
                You shall use Participant Datasets to develop and test your
                models and Entries, provided that you warrant that You have the
                rights to use the Participant Datasets for the purposes of the
                Challenge. You agree to provide Challenge Sponsor with proof of
                such rights and share the Participant Datasets with the
                Challenge Sponsor upon request at any time during the Challenge
                Period or the Challenge evaluation process. You shall indemnify
                and hold harmless the Challenge Sponsor and Challenge Partner
                from and against any claims, damages or loss that Challenge
                Sponsor or Challenge Partners may face from Your use of the
                Participant Datasets for the Challenge.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                B. In adherence to the principles of transparency and
                reproducibility in model training, the top 10 finalists in Track
                1A and top 5 finalists in Track 1B shall be required to submit
                all Participant Datasets utilized during the model training
                process concurrently with the corresponding codebases. This
                ensures a comprehensive review of the resources used within the
                development lifecycle. In instances where specific segments of
                the Participant Datasets are confidential or cannot be disclosed
                due to commercial sensitivity or proprietary constraints, a
                detailed account of these datasets must be provided. This
                account must include the source, volume, and a comprehensive
                description, structured in a manner that enables the Challenge
                Sponsor to accurately ascertain the origin of the datasets in
                question. The finalists shall be required to certify in writing
                that they have permission to use all Participant Datasets that
                was used to develop their solutions. Failure to satisfy any of
                these requirements in this Section 6 shall result in
                disqualification of the finalists from the Competition and
                forfeiture of any prize claim. The Challenge Sponsor’s decision
                shall be final and binding on the Participant.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                C. You warrant that you have obtained all relevant approvals for
                you to apply and participate in the Challenge. The Challenge
                Sponsor and the Challenge Partner shall not be held liable for
                the outputs generated by a model using the prompts created by
                You during the Challenge. You are solely responsible for the
                content You create and submit, including compliance with
                applicable laws and regulations which include without
                limitation, the Computer Misuse Act 1993 and the Cybersecurity
                Act 2018. Outputs generated by the models using the prompts that
                You create under the Challenge are to be used strictly for the
                purposes of refining the output of the models under the
                Challenge only and must not be used in any other context or for
                any other purposes. The Challenge Sponsor will take reasonable
                steps to mitigate potential harm but will not be liable for the
                actions of the Participants or the outputs generated by the
                models from the prompts submitted by the Participants. You shall
                indemnify and hold harmless the Challenge Sponsor, the Challenge
                Partner and any affiliated entities from any claims, damages, or
                liabilities arising from the output generated by the models
                during the Challenge.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                7. SUBMISSION/ENTRY CODE REQUIREMENTS
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                A. Private Code Sharing. Unless otherwise specifically permitted
                under the Challenge Website or Challenge Rules, during the
                Challenge, You are not allowed to privately share source or
                executable code developed in connection with or based upon the
                Participant Datasets with others (the sole exception being
                between members of the same Challenge Team formed in accordance
                with Clause 3C). This prohibition includes code sharing between
                separate Teams. Any such code sharing is a breach of these
                Challenge Rules and shall result in disqualification of the
                Teams from the Challenge.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                B. Public Code Sharing. You are permitted to publicly share
                models or codes, or the model function in connection with or
                based upon the Participant Datasets, or otherwise relevant to
                the Challenge, through the Challenge’s discussion forum,
                provided that such public sharing does not violate the
                intellectual property rights of any third party. By sharing your
                models, codes and/or model function through the Challenge’s
                discussion forum, you are deemed to have licensed the shared
                code under any of the eligible Open Source licenses listed
                below.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                C. Participants are permitted to use permissive open-source
                models and code in the development of their Entries, provided
                that such models and code are licensed under an Open Source
                Initiative (OSI)-approved license (see
                <span>
                  {" "}
                  <a
                    href="https://opensource.org/licenses/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "blue", textDecoration: "underline" }}
                  >
                    Licenses – Open Source Initiative
                  </a>
                </span>
                ) that allows for commercial use of the code or model containing
                or depending on such code. This ensures that any models
                developed can be used for commercial purposes downstream.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                D
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: "SimSun",
                  msoBidiFontFamily: "SimSun",
                  msoFareastLanguage: "ZH-CN",
                }}
              >
                .{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Entries submitted to Challenge Website shall be
                password-protected. Only Challenge Sponsor shall be able to
                access the Entries for evaluation and verification purposes.{" "}
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                E. Participating teams will be entitled to a maximum of{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                }}
              >
                thirty (30) submissions throughout Track 1A and{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                a maximum of{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                }}
              >
                thirty (30) submissions throughout Track 1B. The submission
                portal will be active from the{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                2nd{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                }}
              >
                of{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                July
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                }}
              >
                {" "}
                12:00 PM SGT (UTC+8).
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                F. To ensure equitable participation, as well as regulate
                computational workflow and maintain system integrity,
                participants will not be able{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                }}
              >
                to submit more than seven (7) submissions within a rolling
                2-week window.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                G. No parallel submissions will be accepted. Only one model
                instance per participant can be in operation at any given time.
                You are only allowed to run one model instance at a time, and
                you will not be allowed to upload another submission until the
                current model prediction has been completed or terminated.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                H.<span style={{ msoSpacerun: "yes" }}>&nbsp; </span>
                Participants reserve the right to terminate an ongoing
                submission at their discretion. Such an action will result in
                the clearing of the participant’s workspace, thereby allowing
                the opportunity for a new submission. It is crucial to note,
                however, that a terminated submission will still be deducted
                from the participant's total allowable submissions for both the
                rolling 2-week window and overall Challenge duration.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginBottom: "7.9pt",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              >
                I. Submissions that fail to operate compatibly within the
                competition framework, including but not limited to exceeding
                runtime limitations or discrepancies in input-output formatting,
                will be recorded as an attempt. Each such attempt will
                consequently reduce the participant's remaining submission quota
                for the designated week and the aggregate competition allowance.
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginBottom: "12.0pt",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                J. By participating in the Challenge, Participants shall grant
                the Challenge Sponsor the right to share their Entries with the
                owners of the LLMs used in this Challenge. This sharing is
                specifically intended to facilitate improvements in model
                security.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                8. INTELLECTUAL PROPERTY RIGHTS
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                A. Background IPR. All rights, title and interests in and to any
                intellectual property rights (IPR) created prior to or
                independently of the Challenge which a Participant has the
                right, through ownership or an appropriate licence, to submit as
                an Entry to the Challenge and which is used or disclosed by the
                Participant for the purposes of the Challenge (Background IPR)
                shall remain unaffected. Except as expressly licensed under
                these Challenge Rules, no party is granted any right or interest
                in and to the other party’s Background IPR.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                B. Foreground IPR. Subject to Clause 7A, IPR to all models,
                source code or any other assets created in the course of the
                participation in the Challenge and forming part of the Entry,
                either individually and/or as a Team, will remain the property
                of such Participant/Team (as applicable) and the
                Participant/Team does not assign ownership of any such IPR to
                the Challenge Sponsor and/or its Challenge Partners.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                C. By their submission of Entries, all Participants shall
                automatically grant to the Challenge Sponsor and Challenge
                Partner a perpetual, irrevocable, royalty-free, worldwide and
                non-exclusive licence to use, store and copy the content of any
                of the Entries for the following purposes:
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                (i) to use, reproduce, publicly perform, publicly display and
                create a derivative work from, any Entry that Participant
                submits, solely for the purposes of allowing the Challenge
                Sponsor to test and evaluate the Entry for purposes of the
                Challenge.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                (ii) for non-commercial, academic research and development, and
                education use.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                D. By their submission of Entries, all Participants shall
                automatically grant to the Challenge Sponsor, the Prize Ceremony
                organizers, and Challenge Partner a perpetual, irrevocable,
                royalty-free, worldwide and non-exclusive licence to use, store
                and copy the content of any of the Entries, to advertise,
                display, demonstrate, or otherwise promote the Challenge.
                Participant specifically agrees that the Challenge Sponsor, the
                Prize Ceremony organizers
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                  color: "red",
                }}
              >
                {" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                and/or the Challenge Partner shall have the right to use,
                reproduce, publicly perform, and publicly display the Entry in
                connection with the advertising and promotion of the Challenge
                via communication to the public or other groups, including, but
                not limited to the right to make screenshots, animations and
                video clips available for promotional purposes.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                E. You represent that you have the unrestricted right to grant
                the licence set out in Clause 8C and 8D.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                9. PRIZES
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                A. Prize(s) are as described on the Challenge Website and may be
                replaced, modified, or otherwise amended at any time at the sole
                discretion of the Challenge Sponsor and the Challenge Partner.
                Odds of awarding any prize depends on the number of eligible
                Entries received during the Challenge Period and the quality of
                its output.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                B. This Challenge adopts a dual-leaderboard system, consisting
                of public and private segments, to facilitate a rigorous
                evaluation process. Participants will have access to the Public
                Leaderboard, which will reflect scores derived from evaluating
                the Attack Success Rates (as defined in the Challenge Website)
                for the disclosed LLMs. Conversely, the Private Leaderboard,
                which determines the ultimate competition rankings, will utilize
                scores obtained from all the LLMs. The Private Leaderboard
                scores shall not be visible to the teams and shall be reserved
                exclusively for use by the Challenge Sponsor to ascertain final
                standings of the Participants post-Challenge.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                C. The top ten teams with the best performance based on the
                Private Leaderboard in Track 1A will be selected as finalists
                for Track 1B, based on the rules posted on the Challenge
                Website. These teams will
              </span>
              <span
                lang="EN-US"
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoAnsiLanguage: "EN-US",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                {" "}
                be{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                invited to submit their full code base for verification.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                D. The top five teams with the best performance based on the
                Private Leaderboard in Track 1B will be required to submit their
                full code base and{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                  color: "black",
                  msoColorAlt: "windowtext",
                }}
              >
                a 4-page technical report (including references) describing
                their full end-to-end solutions before the posted deadline. The
                technical report submitted by the finalists must be written
                according to the [
              </span>
              <span style={{ color: "black", msoColorAlt: "windowtext" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    msoBidiFontSize: "11.0pt",
                    fontFamily: '"Arial",sans-serif',
                    msoBidiFontFamily: '"Times New Roman"',
                    msoBidiThemeFont: "minor-bidi",
                    color: "black",
                    msoColorAlt: "windowtext",
                  }}
                >
                  <a
                    href="https://www.acm.org/publications/proceedings-template"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="url-text-styling"
                  >
                    ACM submission guidelines
                  </a>
                </span>
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  msoBidiFontSize: "11.0pt",
                  fontFamily: '"Arial",sans-serif',
                  msoBidiFontFamily: '"Times New Roman"',
                  msoBidiThemeFont: "minor-bidi",
                  color: "black",
                  msoColorAlt: "windowtext",
                }}
              >
                ]
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                . For the avoidance of doubt, teams do not qualify as winners by
                virtue of their Public Leaderboard scores alone.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                E.<span style={{ msoSpacerun: "yes" }}>&nbsp; </span>Each of the
                top ten teams in Track 1A would be paid a flat amount as stipend
                (details available on Challenge website) to partly cover the
                expenses incurred by the team to attend the presentation and
                Prize Ceremony. Each of the top ten teams must identify a
                representative from the team to whom the amount will be paid.
                Teams that are not able to send a representative to attend the
                presentation and/or Prize Ceremony will not be eligible for the
                stipend.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <a name="_Hlk153378197">
                <span
                  style={{
                    fontSize: "10.5pt",
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: "black",
                    msoColorAlt: "windowtext",
                    msoFareastLanguage: "EN-SG",
                  }}
                >
                  F
                </span>
              </a>
              <span style={{ msoBookmark: "_Hlk153378197" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    msoBidiFontSize: "11.0pt",
                    fontFamily: '"Arial",sans-serif',
                    msoBidiFontFamily: '"Times New Roman"',
                    msoBidiThemeFont: "minor-bidi",
                    color: "black",
                    msoColorAlt: "windowtext",
                  }}
                >
                  . In case of a tie on the{" "}
                </span>
              </span>
              <span style={{ msoBookmark: "_Hlk153378197" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: "black",
                    msoColorAlt: "windowtext",
                    msoFareastLanguage: "EN-SG",
                  }}
                >
                  Private{" "}
                </span>
              </span>
              <span style={{ msoBookmark: "_Hlk153378197" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    msoBidiFontSize: "11.0pt",
                    fontFamily: '"Arial",sans-serif',
                    msoBidiFontFamily: '"Times New Roman"',
                    msoBidiThemeFont: "minor-bidi",
                    color: "black",
                    msoColorAlt: "windowtext",
                  }}
                >
                  Leaderboard scores for Track 1A and Track 1B, the secondary
                  metric for determining Leaderboard rankings will be{" "}
                </span>
              </span>
              <span style={{ msoBookmark: "_Hlk153378197" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: "black",
                    msoColorAlt: "windowtext",
                    msoFareastLanguage: "EN-SG",
                  }}
                >
                  input prompt token length.
                </span>
              </span>
              <span style={{ msoBookmark: "_Hlk153378197" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    msoBidiFontSize: "11.0pt",
                    fontFamily: '"Arial",sans-serif',
                    msoBidiFontFamily: '"Times New Roman"',
                    msoBidiThemeFont: "minor-bidi",
                    color: "black",
                    msoColorAlt: "windowtext",
                  }}
                >
                  {" "}
                  To resolve the tie, we will compare the{" "}
                </span>
              </span>
              <span style={{ msoBookmark: "_Hlk153378197" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: "black",
                    msoColorAlt: "windowtext",
                    msoFareastLanguage: "EN-SG",
                  }}
                >
                  average input prompt token length for the behaviours for
                </span>
              </span>
              <span style={{ msoBookmark: "_Hlk153378197" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    msoBidiFontSize: "11.0pt",
                    fontFamily: '"Arial",sans-serif',
                    msoBidiFontFamily: '"Times New Roman"',
                    msoBidiThemeFont: "minor-bidi",
                    color: "black",
                    msoColorAlt: "windowtext",
                  }}
                >
                  {" "}
                  each tied team’s highest-performing{" "}
                </span>
              </span>
              <span style={{ msoBookmark: "_Hlk153378197" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: "black",
                    msoColorAlt: "windowtext",
                    msoFareastLanguage: "EN-SG",
                  }}
                >
                  submission. The team with the shorter average input prompt
                  token length will be ranked higher.
                </span>
              </span>
              <span style={{ msoBookmark: "_Hlk153378197" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    msoBidiFontSize: "11.0pt",
                    fontFamily: '"Arial",sans-serif',
                    msoBidiFontFamily: '"Times New Roman"',
                    msoBidiThemeFont: "minor-bidi",
                    color: "black",
                    msoColorAlt: "windowtext",
                  }}
                >
                  {" "}
                </span>
              </span>
              <span style={{ msoBookmark: "_Hlk153378197" }}>
                <span
                  style={{
                    fontSize: "10.5pt",
                    msoBidiFontSize: "11.0pt",
                    fontFamily: '"Arial",sans-serif',
                    msoBidiFontFamily: '"Times New Roman"',
                    msoBidiThemeFont: "minor-bidi",
                  }}
                ></span>
              </span>
            </p>
            <span style={{ msoBookmark: "_Hlk153378197" }} />
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                G. Challenge Sponsor will declare the top three (3) Entries in
                Track 1B as winners by email during the dates specified on the
                Challenge Website. If a winner does not respond to the
                notification within{" "}
              </span>
              <span
                lang="EN-US"
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoAnsiLanguage: "EN-US",
                  msoFareastLanguage: "ZH-CN",
                }}
              >
                three (3){" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                days from the date of such notification, then the Challenge
                Sponsor may in their sole discretion, disqualify such winner and
                select an alternate winner from among all eligible entries
                received, based on the evaluation results. The winning teams
                will be invited to submit a final presentation and to elect a
                representative for an in-person final presentation and showcase
                of their solution at the Prize Ceremony. Winners who are not
                able to make it for the presentation or prize ceremony will be
                disqualified, and an alternate winner will be selected from
                among all eligible entries received.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <a name="_Hlk115862070">
                <span
                  style={{
                    fontSize: "10.5pt",
                    fontFamily: '"Arial",sans-serif',
                    msoFareastFontFamily: '"Times New Roman"',
                    color: "black",
                    msoColorAlt: "windowtext",
                    msoFareastLanguage: "EN-SG",
                  }}
                >
                  H. Challenge Sponsor reserves the right, at its sole and
                  absolute discretion, to not award any prizes for the
                  Challenge, should the number of Entries received and/or the
                  quality of these Entries not meet the expected levels. The
                  Challenge Sponsor’s decision shall be final and binding.{" "}
                </span>
              </a>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                I. All prizes are subject to Challenge Sponsor’s review and
                verification of the Participant’s eligibility and compliance
                with these Challenge Rules, and the compliance of the winning
                Entries with the Requirements. In the event that the Entry
                demonstrates non-compliance with these Challenge Rules,
                Challenge Sponsor may, at its discretion, take either of the
                following actions: (i) disqualify the Entry(ies); or (ii)
                require the prize winner to remedy any non-compliance within one
                week after notice of all issues identified in the Entry(ies)
                (including, without limitation, the resolution of license
                conflicts, the fulfilment of all obligations required by
                software licenses, and the removal of any software that violates
                the software restrictions).
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                J. A prize winner may decline accepting the prize by notifying
                Challenge Sponsor directly within one (1) week from receipt of
                win notification in which case such prize winner shall forego
                any prize or other benefits associated with winning the
                Challenge. Challenge Sponsor reserve the right to disqualify a
                Participant who so declines the prize.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                K. Prize winners must submit all required documents within five
                (5) days of receiving a notification from the Challenge Sponsor,
                or such winner will be deemed to have forfeited the prize and
                another winner may be selected by the Challenge Sponsor at its
                sole and absolute discretion. Prize(s) shall be awarded within
                approximately thirty (30) days after receipt by Challenge
                Sponsor of the required prize acceptance documents. Transfer or
                assignment of a prize is not allowed.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                L. You are not eligible to receive any prize if you do not meet
                the Eligibility Criteria in Section 2 above.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                10. WINNERS’ OBLIGATIONS
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                As a condition to being awarded a prize, a prize winner must
                fulfil the following obligations:
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                (a) sign and return all prize acceptance documents as may be
                required by Challenge Sponsor, including without limitation: (i)
                eligibility certifications; (ii) licences, releases and other
                agreements required under the Challenge terms and conditions;
                (iii) relevant tax forms, if any; (iv) source code; (v) a
                complete report with technology details of the winning solution
                in the format and/or utilising the template provided by
                Challenge Sponsor and (vi) other relevant materials requested by
                Challenge Sponsor including without limitation, bank accounts;
                and
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                (b) agree to allow the Challenge Sponsor and/or Challenge
                Partners to use your name, trademark and/or likeness, free of
                charge for advertising and promotional purposes, unless
                prohibited by law.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Further, you agree that it is your responsibility to ensure that
                any information provided by you (including without limitation,
                bank accounts) are correct, true and accurate and you agree to
                defend, indemnify and hold harmless the Challenge Sponsor and
                the Challenge Partner from and against any and all claims,
                actions, suits or proceedings, as well as any and all losses,
                liabilities, damages, costs and expenses (including without
                limitation, transfers to erroneous bank accounts) arising out of
                or in connection with any information provided by you under this
                Clause 10.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                11. TAXES
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                ALL TAXES IMPOSED ON PRIZES ARE THE SOLE RESPONSIBILITY OF THE
                WINNERS. Payments to winners are subject to the express
                requirement that they submit all documentation requested by
                Challenge Sponsor for compliance with applicable state, federal,
                local and foreign (including provincial) tax reporting and
                withholding requirements. Prizes will be net of any taxes that
                Challenge Sponsor is required by law to withhold.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                12. DISQUALIFYING BEHAVIOUR
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Challenge Sponsor reserves the right to disqualify any
                Participant from the Challenge if, in Challenge Sponsor’s sole
                discretion, it reasonably believes that the Participant has
                attempted to undermine the legitimate operation of the Challenge
                by cheating, deception, or other unfair playing practices or for
                any abuse, threats or harassments of any other Participants or
                Challenge Sponsor.
              </span>
              <span style={{ color: "black", msoColorAlt: "windowtext" }}>
                {" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Challenge Sponsor further reserves the right to disqualify any
                Participant who tampers with the submission process or any other
                part of the Challenge or Challenge Website. Any attempt by a
                Participant to deliberately damage any website, including the
                Challenge Website, or undermine the legitimate operation of the
                Challenge is a violation of criminal and civil laws and should
                such an attempt be made, Challenge Sponsor each reserves the
                right to seek damages from any such Participant to the fullest
                extent of the applicable law.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                13. PRIVACY
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                You acknowledge and agree that Challenge Sponsor may collect,
                store, share and otherwise use personally identifiable
                information provided during the registration process and the
                Challenge, including, but not limited to, name, mailing address,
                phone number, and email address. Challenge Sponsor will use this
                information in accordance with its Privacy Policy, including for
                administering the Challenge. Your information may also be
                transferred to countries outside the country of your residence.
                Such other countries may not have privacy laws and regulations
                similar to those of the country of your residence. As a
                registered participant on the Challenge Website, You have the
                right to request access, review, rectification or deletion of
                any personal data held by Challenge Sponsor by logging into your
                account and/or sending an email request.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Challenge Sponsor is committed to safeguard the privacy and
                confidentiality of your personal data. By participating in this
                Challenge and/or accepting any of the prizes awarded, You
                acknowledge that the Challenge Sponsor may use your name,
                address, comments, likenesses, photos (including photos taken of
                the winners at the Prize Ceremony), and descriptions of your
                ideas in publicity or advertising campaigns or materials
                concerning the competition or otherwise in any medium now known
                or hereafter devised (including the Internet or other
                interactive networks) at any place or time without further
                compensation or right of review, and You agree to waive your
                rights with respect to any such publicity and advertising.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                14. WARRANTY, INDEMNITY AND RELEASE
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                You warrant that your Entry is your own original work and, as
                such, you are the sole and exclusive owner and rights holder of
                the Entry, and you have the right to make the Entry and grant
                all required licences. You agree not to submit any Entry that:
                (i) knowingly infringes any third-party proprietary rights,
                intellectual property rights, industrial property rights,
                personal or moral rights or any other rights, including without
                limitation, copyright, trademark, patent, trade secret, privacy,
                publicity or confidentiality obligations; or (ii) otherwise
                violates any applicable state or federal law.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                To the maximum extent permitted by law, you indemnify and agree
                to keep indemnified Challenge Sponsor and Challenge Partner at
                all times from and against any liability, claims, demands,
                losses, damages, costs and expenses resulting from any act,
                default or omission of the Participant and/or a breach of any
                warranty set forth herein. To the maximum extent permitted by
                law, you agree to defend, indemnify and hold harmless the
                Challenge Sponsor and the Challenge Partner from and against any
                and all claims, actions, suits or proceedings, as well as any
                and all losses, liabilities, damages, costs and expenses
                (including reasonable attorney’s fees) arising out of or
                accruing from: (a) your Entry or other material uploaded or
                otherwise provided by You that infringes any copyright,
                trademark, trade secret, trade dress, patent or other
                intellectual property right of any person or entity, or defames
                any person or violates their rights of publicity or privacy; (b)
                any misrepresentation made by You in connection with the
                Challenge; (c) any non-compliance by You with these Challenge
                Rules; (d) claims brought by persons or entities other than the
                parties to these Challenge Rules arising from or related to your
                involvement with the Challenge;
                <span style={{ msoSpacerun: "yes" }}>&nbsp;</span>(e) your
                acceptance, possession, misuse or use of any prize, or your
                participation in the Challenge and any Challenge -related
                activity.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                You hereby release the Challenge Sponsor, Challenge Partner and
                Challenge Entities from any liability associated with: (a) any
                malfunction or other problem with the Challenge Website; (b) any
                error in the collection, processing, or retention of any Entry;
                or (c) any typographical or other error in the printing,
                offering or announcement of any prize, finalists or winners.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Save for death or personal injuries caused by negligence, in no
                event shall You or the Challenge Sponsor, Challenge Partner
                (including their employees, interns, apprentices, contractors,
                officers and directors) and Challenge Entities, whether as a
                breach of contract, tort or otherwise, have any liability to
                each other or to a third party for any indirect, special,
                incidental, consequential damages, loss of profits or pure
                economic loss.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                15. INTERNET
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Challenge Entities are not responsible for any malfunction of
                the Challenge Website or any late, lost, damaged, misdirected,
                incomplete, illegible, undeliverable, or destroyed Entries or
                entry materials due to system errors, failed, incomplete or
                garbled computer or other telecommunication transmission
                malfunctions, hardware or software failures of any kind, lost or
                unavailable network connections, typographical or system/human
                errors and failures, technical malfunction(s) of any telephone
                network or lines, cable connections, satellite transmissions,
                servers or providers, or computer equipment, traffic congestion
                on the Internet or at the Challenge Website, or any combination
                thereof, which may limit a Participant’s ability to participate.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                16. RIGHT TO CANCEL, MODIFY
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                If for any reason the Challenge is not capable of running as
                planned, including infection by computer virus, bugs, tampering,
                unauthorized intervention, fraud, technical failures, or any
                other causes which corrupt or affect the administration,
                security, fairness, integrity, or proper conduct of the
                Challenge, Challenge Sponsor reserves the right at its sole
                discretion to cancel, terminate, modify or suspend the
                Challenge.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                The Challenge Sponsor reserves the rights to update or amend
                these Terms and Conditions from time to time and you acknowledge
                that it is your responsibility to conduct periodic checks on
                these Terms and Conditions.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                17. NOT AN OFFER OR CONTRACT OF EMPLOYMENT
              </span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "7.9pt",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Unless otherwise specifically provided under the Challenge
                Website, under no circumstances shall the submission of an
                Entry, the awarding of a prize, or anything in these Challenge
                Rules be construed as an offer or contract of employment with
                the Challenge Sponsor, the Challenge Partner or any of the
                Challenge Entities. You acknowledge that you have submitted your
                Entry voluntarily and not in confidence or in trust. You
                acknowledge that no confidential, fiduciary, agency or other
                relationship or implied-in-fact contract now exists between you
                and the Challenge Sponsor, Challenge Partner or any of the
                Challenge Entities, and that no such relationship is established
                by your submission of the Entry.
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: ".25in",
                marginRight: "0in",
                marginBottom: "12.0pt",
                marginLeft: "0in",
                lineHeight: "normal",
                msoOutlineLevel: 3,
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                18. GOVERNING LAW AND DISPUTE RESOLUTION
              </span>
              <span
                lang="EN-US"
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoAnsiLanguage: "EN-US",
                  msoFareastLanguage: "ZH-CN",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "0in",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Unless otherwise provided in the Challenge Rules above, this
                Agreement will be governed by Singapore law. You agree that to
                submit to the exclusive jurisdiction of the courts of the
                Republic of Singapore
              </span>
              <span style={{ color: "black", msoColorAlt: "windowtext" }}>
                {" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                for any claims or disputes arising in relation with the
                Challenge. A person who is not a party to the Agreement has not
                right under the Contracts (Rights of Third Parties) Act 2001 to
                enforce any of these terms and conditions.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "0in",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                Any dispute arising from or in connection with this Agreement,
                including any question regarding its existence, validity or
                termination, shall first be
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  color: "black",
                  msoColorAlt: "windowtext",
                }}
              >
                {" "}
                referred to the authorised representatives of the Parties
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                {" "}
                for amicable settlement through good faith negotiations.{" "}
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  color: "black",
                  msoColorAlt: "windowtext",
                }}
              >
                Any dispute which cannot be resolved by amicable discussions
                within thirty (30) days of referral shall be submitted to the
                Presidents (or equivalent) of the respective Parties or their
                nominees for resolution. If the Parties fail to resolve such
                dispute through good faith negotiations, such dispute shall be
                referred to and
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                {" "}
                finally resolved by arbitration administered by the Singapore
                International Arbitration Centre (the SIAC) in accordance with
                the Arbitration Rules of the SIAC (SIAC Rules) for the time
                being in force, which rules are deemed to be incorporated by
                reference in this Clause. The seat of the arbitration shall be
                Singapore. The tribunal shall consist of one (1) arbitrator. The
                language of the arbitration shall be English.
                <span style={{ msoSpacerun: "yes" }}>&nbsp; </span>
              </span>
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "0in",
                marginLeft: "0in",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                19. SEVERABILITY
              </span>
              <span
                style={{
                  fontSize: "13.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  msoFareastLanguage: "EN-SG",
                }}
              ></span>
            </p>
            <p
              className="MsoNormal"
              style={{
                marginTop: "7.9pt",
                marginRight: "0in",
                marginBottom: "0in",
                marginLeft: "0in",
                textAlign: "justify",
                textJustify: "inter-ideograph",
                lineHeight: "normal",
                background: "white",
                verticalAlign: "baseline",
              }}
            >
              <span
                style={{
                  fontSize: "10.5pt",
                  fontFamily: '"Arial",sans-serif',
                  msoFareastFontFamily: '"Times New Roman"',
                  color: "black",
                  msoColorAlt: "windowtext",
                  msoFareastLanguage: "EN-SG",
                }}
              >
                If any provision of these Challenge Rules is held to be invalid
                or unenforceable, all remaining provisions of the Challenge
                Rules will remain in full force and effect.
              </span>
            </p>
            <p className="MsoNormal">&nbsp;</p>
          </div>
        </Container>
      </Paper>
    </div>
  );
};

export default TermsAndConditions;
